import PropTypes from 'prop-types'

const propTypes = {
  entity: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
}

export default propTypes
